enum Modals {
  whyNow = 'whyNow',
}

export default {
  [Modals.whyNow]: {
    component: 'LazyWhyNowModal',
    props: { transition: { name: 'fade' } },
  },
};
